/* Auth */
export const RESET_AUTH = 'resetAuth';
export const PURGE_AUTH = 'purgeAuth';
export const SET_TOKEN = 'setToken';

/* Group */
export const SET_ARTICLE_GROUPS = 'setArticleGroups';
export const SET_ARTICLE_NAMES = 'setArticleNames';
export const SET_MIXER_ITEMS = 'setMixerItems';
export const SET_MANAGEMENT_GROUPS = 'setManagementGroups';
export const SET_MIXER_GROUPS = 'setMixerGroups';

/* Article */
export const SAVE_ARTICLE = 'saveArticle';

/* Dashboard */
export const INIT_DASHBOARD_DATA = 'initDashboardData';

/* Stock */
export const SET_ARTICLES = 'setArticles';
export const SAVE_REORDER = 'saveReOrder';
export const DELETE_REORDER = 'deleteReOrder';

/* Mixer */
export const SET_MIXERS = 'setMixers';
export const SET_PRODUCT_MIXERS = 'setProductMixers';
export const SET_MIXERS_ARTICLES = 'setMixersArticles';

/* Toggle */
export const SET_DRAWER = 'setDrawer';
export const RESET_ALL_TOGGLE = 'resetAllToggle';
export const SET_MESSAGE_MODAL = 'setMessageModal';
export const TOGGLE_BILL_MODAL_VISIBLE = 'toggleBillModalVisible';
export const TOGGLE_PAGE_IS_LOADING = 'togglePageIsLoading';
export const SET_ACTIVE_ELEMENT = 'setActiveElement';
export const START_LOADING = 'startLoading';
export const END_LOADING = 'endLoading';
export const SET_TABLE_DIALOG = 'setTableDialog';

/* Recipe */
export const SET_RECIPE_STATE = 'setRecipeState';

/* Location */
export const SAVE_LOCATION = 'saveLocation';
export const SAVE_STATION = 'saveStation';
export const DELETE_STATION = 'deleteStation';

/** Report */
export const INIT_REPORT_DATA = 'initReportData';
